import axiosRequest from './axios.js'

export default {
  //黑名单列表查询
  blackList (params) {
    return axiosRequest.post('dji/fuzzy_search/blacklist', params)
  },
  //获取个人详情-用户详情
  queryUser (params) {
    return axiosRequest.get('dji/detail/queryUser?' + params)
  },
  //获取个人详情-基础数据
  queryBase (params) {
    return axiosRequest.get('dji/detail/queryBase?' + params)
  },
  //列入风险名单原因
  queryReason (params) {
    return axiosRequest.get('dji/detail/queryReason', params)
  },
  //关联关系机构查询
  queryEntity (params) {
    return axiosRequest.get('dji/detail/queryEntity?' + params)
  },
  //关联关系个人查询
  queryPerson (params) {
    return axiosRequest.get('dji/detail/queryPerson?' + params)
  },
  //关联关系机构图谱
  queryEntityMap (params) {
    return axiosRequest.get('dji/detail/queryEntityMap?' + params)
  },
  //关联关系个人图谱
  queryPersonMap (params) {
    return axiosRequest.get('dji/detail/queryPersonMap?' + params)
  },
  //获取职业信息
  queryOccupation (params) {
    return axiosRequest.get('dji/detail/queryOccupation?' + params)
  },
  //获取地图图谱
  queryAddressMap (params) {
    return axiosRequest.get('dji/detail/queryAddressMap?' + params)
  },
  //获取地图表单
  queryArea (params) {
    return axiosRequest.get('dji/detail/queryArea?' + params)
  },
  //更多信息
  queryMoreInfo (params) {
    return axiosRequest.get('dji/detail/queryMoreInfo?' + params)
  },
  //新闻来源
  queryNewsSource (params) {
    return axiosRequest.get('dji/detail/queryNewsSource?', params)
  },
  //黑名单字典
  queryDictList (params) {
    return axiosRequest.get('dji/dictionary/queryDictList?' + params)
  },
  //任务命中情况查询
  queryHitDetail (params) {
    return axiosRequest.get('dji/batch_screen/queryHitDetail?' + params)
  },
  //批量筛查
  batchScreen (params) {
    return axiosRequest.post('dji/batch_screen/batchScreen', params)
  },
  //任务列表查询
  queryTask (params) {
    return axiosRequest.get('dji/batch_screen/queryTask', params)
  },
  //下载Excel模板
  downloadExcel (params) {
    return axiosRequest.get('dji/batch_screen/downloadExcel', params)
  },
  //删除任务
  deleteTask (params) {
    return axiosRequest.delete('dji/batch_screen/deleteTask?' + params)
  },
  //导出人工核对审核流水pdf
  exportPDF (params) {
    return axiosRequest.get('dji/manual_check/exportPDF?' + params)
  },
  //导出筛查记录审核流水pdf
  exportPDF2 (params) {
    return axiosRequest.get('dji/screen/exportPDF', params)
  },
  //任务导出excel
  exportTask (params) {
    return axiosRequest.get('dji/batch_screen/exportTask?' + params)
  },
  //人工审核列表查询
  queryFlow (params) {
    return axiosRequest.post('dji/manual_check/queryFlow', params)
  },
  //人工审核列表详情查询
  queryFlowDetail (params) {
    return axiosRequest.post('dji/manual_check/queryFlowDetail', params)
  },
  //备注列表查询
  queryRemarksList (params) {
    return axiosRequest.post('dji/serial_remark/query', params)
  },
  //提交备注
  submitRemark (params) {
    return axiosRequest.post('dji/serial_remark/add', params)
  },
  //删除备注
  deleteRemark (params) {
    return axiosRequest.post('dji/serial_remark/delete', params)
  },
  //筛查记录列表查询
  queryFlow2 (params) {
    return axiosRequest.post('dji/screen/queryFlow', params)
  },
  //初审
  firstCheck (params) {
    return axiosRequest.post('dji/manual_check/firstCheck', params)
  },
  //复审
  reCheck (params) {
    return axiosRequest.post('dji/manual_check/reCheck', params)
  },
  //根据id查询当前流水信息
  queryFlowInfo (id) {
    return axiosRequest.get('dji/detail/queryFlow?id=' + id)
  },

  /* KYC2.0版本 QME增加 */
  //权限验证
  vertifyAuth (param) {
    return axiosRequest.get('/qme/taskFlow/vertifyAuth?enterpriseName=' + param)
  },
  //下载报告
  createTask (param) {
    return axiosRequest.post('/qme/taskFlow/createTask', param)
  },
  //字典查询
  queryDictList1 (param) {
    return axiosRequest.get('/dict/queryDictList?' + param)
  },
  //流水查询
  list (param) {
    return axiosRequest.get('/qme/taskFlow/list', param)
  },
  //删除流水接口
  deleteFlow (param) {
    return axiosRequest.delete('/qme/taskFlow/deleteFlow', param)
  },
  //查看密码接口
  scanPassword (param) {
    return axiosRequest.get('/qme/taskFlow/scanPassword?serialNo=' + param)
  },
  //下载文档接口
  downloadFile (param) {
    return axiosRequest.get('/qme/taskFlow/downloadFile?serialNo=' + param)
  }
}



// WEBPACK FOOTER //
// ./src/api/apiDQS.js